(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kiki-character-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kiki-character-directory')) {
    customElements.define('kiki-character-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const requestedGroup = new URL(location.href).searchParams.get('group') || location.hash.slice(1);
        this.kind = ['characters','families','brands'].includes(requestedGroup) ? requestedGroup : 'all';
        this.querySelector('input').addEventListener('input', () => this.update());
        this.querySelectorAll('button[data-kind]').forEach(button => button.addEventListener('click', () => {
          this.kind = button.dataset.kind;
          this.update();
        }));
        this.update();
      }
      update() {
        const query = this.querySelector('input').value.trim().toLocaleLowerCase();
        let count = 0;
        this.querySelectorAll('[data-directory-card]').forEach(card => {
          card.hidden = !(this.kind === 'all' || card.dataset.cardKind === this.kind) || !card.dataset.name.includes(query);
          if (!card.hidden) count++;
        });
        this.querySelectorAll('[data-directory-group]').forEach(group => { group.hidden = !group.querySelector('[data-directory-card]:not([hidden])'); });
        this.querySelectorAll('button[data-kind]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.kind === this.kind)));
        this.querySelector('[role=status]').textContent = `${this.dataset.resultLabel} ${count}`;
        this.querySelector('[data-directory-empty]').hidden = count > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
